import React from 'react';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import { useQueryString } from 'helpers/effects';
import NotificationTypeListContainer from 'components/NotificationType/List';

const ScreenNotificationTypeList = () => {
  const initialFilters = useQueryString();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <NotificationTypeListContainer initialFilters={initialFilters} />
      </GridItem>
    </GridContainer>
  );
};
export default ScreenNotificationTypeList;
